<div class="main-element">
  <opac-skeleton></opac-skeleton>

  <div class="content">
    <opac-skeleton></opac-skeleton>
    <opac-skeleton></opac-skeleton>
  </div>
</div>

<div *ngFor="let _ of [1, 2, 3]" class="element">
  <opac-skeleton></opac-skeleton>

  <div class="content">
    <opac-skeleton></opac-skeleton>
    <opac-skeleton></opac-skeleton>
  </div>
</div>

